<div class="mindtree-wrap">
  <div #treeContainer style="width:100%;height:100%"></div>
  <span class="mindtree-hint">Scroll to zoom &nbsp;·&nbsp; Drag to pan</span>
</div>
